// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2411":"168168ff","4056":"168168ff","4338":"168168ff","6814":"7bbe8dfc","8597":"168168ff","8623":"168168ff","9245":"0c1eca38"}[chunkId] + ".chunk.css";
};